import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import type {Optional} from '@yandex-delivery/types'
import {addQuery, get, isEmpty, isUndefined} from '@yandex-delivery/utils'
import {sort} from '@yandex-delivery/utils/timezone'

import type {
  NddClaim,
  NddClaimDeliveryInterval,
  NddClaimDeliveryIntervals,
  NddClaimDeliveryTimeInterval,
} from 'src/shared/types'

import {appConfig} from '../../config'
import {fetch} from '../fetch'

const getMinPickupInterval: (offer?: NddClaimDeliveryInterval) => Optional<string | number> = get(
  'offer_details.pickup_interval.min',
)
const getMinDeliveryInterval: (offer?: NddClaimDeliveryInterval) => Optional<string | number> = get(
  'offer_details.delivery_interval.min',
)
const getMaxDeliveryInterval: (offer?: NddClaimDeliveryInterval) => Optional<string | number> = get(
  'offer_details.delivery_interval.min',
)

function findClosestOffer(
  offers?: NddClaimDeliveryInterval[],
  searchInterval?: NddClaimDeliveryTimeInterval,
): Optional<NddClaimDeliveryInterval> {
  if (isUndefined(offers) || isEmpty(offers) || isUndefined(searchInterval)) {
    return undefined
  }

  const sortedOffers = offers
    .sort((a, b) => sort(getMinPickupInterval(a), getMinPickupInterval(b)))
    .sort((a, b) => sort(getMinDeliveryInterval(a), getMinDeliveryInterval(b)))

  const offerWithSameTimeInterval = sortedOffers.find(offer => {
    const minDeliveryInterval = getMinDeliveryInterval(offer)
    const maxDeliveryInterval = getMaxDeliveryInterval(offer)

    return minDeliveryInterval === searchInterval.from && maxDeliveryInterval === searchInterval.to
  })

  return offerWithSameTimeInterval || sortedOffers[0]
}

export async function fetchClosestOfferDeprecated(
  order: Partial<NddClaim>,
): Promise<Optional<NddClaimDeliveryInterval>> {
  const result = await fetch<Partial<NddClaim>, Optional<NddClaimDeliveryInterval>, NddClaimDeliveryIntervals>({
    url: addQuery(externalApiURL('platform/integration/offers/create'), {country: appConfig.countryCode}),
    method: 'POST',
    body: order,
  })

  return findClosestOffer(result?.offers, order.destination?.interval_utc)
}
